import { Loader, icons } from '@lifebit-ai/lds'
import { ResultsState } from 'enums'
import React, { ReactElement } from 'react'

import { StatusIconWrapper, StatusWrapper } from './Results.styles'

type Props = {
  status: ResultsState
}

const getResultStatusIcon = (status: ResultsState): ReactElement | null => {
  switch (status) {
    case ResultsState.Complete:
      return (
        <StatusIconWrapper status={status}>
          <icons.CheckInCircleSmall data-testid="result-complete-icon" />
        </StatusIconWrapper>
      )
    case ResultsState.PendingVerification:
      return (
        <StatusIconWrapper status={status}>
          <icons.ClockSmall data-testid="result-pending-icon" />
        </StatusIconWrapper>
      )
    case ResultsState.Rejected:
      return (
        <StatusIconWrapper status={status}>
          <icons.CloseInCircleSmall data-testid="result-rejected-icon" />
        </StatusIconWrapper>
      )
    case ResultsState.Failed:
      return (
        <StatusIconWrapper status={status}>
          <icons.ErrorSmall data-testid="result-failed-icon" />
        </StatusIconWrapper>
      )
    case ResultsState.Preparing:
      return (
        <StatusIconWrapper status={status}>
          <Loader text={false} data-testid="result-preparing-icon" />
        </StatusIconWrapper>
      )
    case ResultsState.Processing:
      return (
        <StatusIconWrapper status={status}>
          <Loader text={false} data-testid="result-processing-icon" />
        </StatusIconWrapper>
      )
    default:
      return null
  }
}

const getStatusText = (status: ResultsState): string => {
  switch (status) {
    case ResultsState.Complete:
      return 'Approved'
    case ResultsState.PendingVerification:
      return 'Pending'
    case ResultsState.Rejected:
      return 'Rejected'
    case ResultsState.Failed:
      return 'Failed'
    case ResultsState.Preparing:
      return 'Preparing...'
    case ResultsState.Processing:
      return 'Processing...'
    default:
      return 'Invalid status'
  }
}

const ResultStatusTag = ({ status }: Props) => {
  const icon = getResultStatusIcon(status)
  const text = getStatusText(status)
  if (!icon) return null
  return (
    <StatusWrapper>
      <StatusIconWrapper status={status}>{icon}</StatusIconWrapper>
      {text}
    </StatusWrapper>
  )
}

export default ResultStatusTag
